import * as React from 'react';

export interface LoaderProps {
	color: string;
	className?: string;
}

export const Loader = (props: LoaderProps) => {
	return (
		<div className={'loader' + (props.className ? ' ' + props.className : '')} style={({ color: props.color })}>
			<div className='spinner' style={({ backgroundColor: props.color })}/>
		</div>
	);
};
